import { useEffect } from 'react';
import { addEventListener } from '../utils/dom';
import { getHookEventElement } from '../utils/internal/getHookEventElement';
import { useEvent } from './useEvent';
/** Hook for `addEventListener` */
export function useEventListener(_a) {
    var ref = _a.ref, target = _a.target, listenerProp = _a.listener, options = _a.options, isDisabled = _a.isDisabled, getIsDisabledProp = _a.getIsDisabled;
    var getIsDisabled = useEvent(getIsDisabledProp);
    var listener = useEvent(listenerProp);
    useEffect(function () {
        var isGetDisabled = getIsDisabled ? getIsDisabled() : false;
        if (isDisabled || isGetDisabled) {
            return undefined;
        }
        var element = getHookEventElement(ref);
        if (!element) {
            return undefined;
        }
        return addEventListener(element, target, listener, options);
    }, [listener, options, ref, isDisabled, target, getIsDisabled]);
}
//# sourceMappingURL=useEventListener.js.map